export default "__VITE_ASSET__CjnDY0tv__"